import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import LazyRoute from '@/components/LazyRoute'

const searchSchema = z.object({
  plan: z.string().optional(),
  trial: z.coerce.boolean().optional(),
})

export const Route = createFileRoute('/_protected/organization/settings/billing')({
  component: () => (
    <LazyRoute
      loader={() => import('@/components/organization-settings/billing')}
      fallback={<div>Loading...</div>}
    />
  ),
  validateSearch: searchSchema,
})